export const iconFontAwesomeChartsDiagramsChartLine = (
	<i className="fa-solid fa-chart-line"></i>
);
